// extracted by mini-css-extract-plugin
module.exports = {"title":"rentCar_title__1rKXJ","containerHeader":"rentCar_containerHeader__1YBpN"};